import { authSelector } from "../store/selectors/index";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { message } from "antd";

// Define the PrivateRoute component
function PrivateRoute({ element, allowedRoles }) {
  // Get the user object from the Redux store
  const { user } = useSelector(authSelector);

  // Check if the user is authenticated and their role matches the allowed roles
  if (user && allowedRoles.includes(user.role)) {
    return element;
  } else {
    // Redirect to the home page if the user is not authenticated or their role is not allowed
    message.error(
      <span>
        Role <strong>{user.role}</strong> is not allowed to access this resource
      </span>
    );

    return <Navigate to="/mainScreen" />;
  }
}

export default PrivateRoute;
